import { service } from "@ember/service";
import Controller from "@ember/controller";
import { action } from "@ember/object";
import { task } from "ember-concurrency";
import { tracked } from "@glimmer/tracking";
import ENV from "glesys-controlpanel/config/environment";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class DashboardSettingsController extends Controller {
  @service ajax;
  @service intl;
  @service session;
  @service notification;
  @service storage;
  @service store;

  @tracked selectedLocale = this.intl.primaryLocale;

  get currentLocale() {
    return this.intl.primaryLocale;
  }

  onLanguageChange = ({ locale }) => (this.selectedLocale = locale);

  switchLanguageTask = task(async () => {
    this.intl.setLocaleIfValid(this.selectedLocale);
    this.storage.set("glesys:locale", this.intl.primaryLocale);
  });

  get user() {
    return this.session.currentUser;
  }

  get isYubiKey() {
    return this.user.twoFactorMethod === "yubikey";
  }

  @tracked passwordCurrent = null;
  @tracked passwordNew = null;
  @tracked passwordOneTimePassword = null;

  @action
  onUserDetailsFormChange({ name }) {
    this.user.name = name;
  }

  @action
  onPasswordFormChange({ passwordCurrent, passwordNew, passwordOneTimePassword }) {
    this.passwordCurrent = passwordCurrent;
    this.passwordNew = passwordNew;
    this.passwordOneTimePassword = passwordOneTimePassword;
  }

  updateToExternalTwoFactorTask = task(async (method, secret, verification) => {
    await this.ajax
      .post(`${ENV.apiBaseUri}/user/enabletwofactor`, {
        data: {
          method,
          secret,
          verification,
        },
      })
      .then(() => {
        this.send("logout", "updated-to-external-2fa");
      });
  });

  revertToEmailBasedTwoFactorTask = task(async (otp, password) => {
    await this.ajax
      .post(`${ENV.apiBaseUri}/user/disabletwofactor`, {
        data: {
          password,
          otp,
        },
      })
      .then(() => {
        this.send("logout", "revert-to-email-based");
      });
  });

  saveDetailsTask = task(async () => {
    let user = this.user;
    await this.store.request(saveRecord(user));
  });

  changePasswordTask = task(async () => {
    let currentpassword = this.passwordCurrent;
    let newpassword = this.passwordNew;
    let otp = this.passwordOneTimePassword;

    await this.ajax
      .post(`${ENV.apiBaseUri}/user/changepassword`, {
        data: {
          currentpassword,
          newpassword,
          otp,
        },
      })
      .then(() => {
        this.passwordCurrent = null;
        this.passwordNew = null;
        this.passwordOneTimePassword = null;
        this.send("logout", "reset");
      })
      .catch((error) => {
        if (error.content?.response?.status?.code === 1601) {
          this.notification.add(
            "error",
            this.intl.t("dashboard.settings.change-password.title"),
            this.intl.t("dashboard.settings.change-password.invalid"),
          );
          return;
        }

        throw error;
      });
  });
}
